module.exports = __webpack_public_path__ + "static/media/customerCount.fd1d0dbf.svg";